import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import "./Donate.css";

const DONATE_CONFIG = {
  saweria: {
    name: "Saweria",
    description:
      "Support kami melalui Saweria. Donasi Anda membantu kami menjaga dan mengembangkan platform ini.",
    url: "https://saweria.co/defilms",
  },

  wallets: [
    {
      name: "Bitcoin",
      symbol: "BTC",
      address: "bc1q9d9t584rqx8al6lgzdry9f3z6ensuljl854kaz",
      qrImage: "/assets/donate/btc.jpeg",
      icon: "₿",
      color: "bitcoin",
    },

    {
      name: "Litecoin",
      symbol: "LTC",
      address: "ltc1q6q67txrqmdtucdymnjv9pxntat3tmng4rw82zn",
      qrImage: "/assets/donate/ltc.jpeg",
      icon: "Ł",
      color: "litecoin",
    },

    {
      name: "Ethereum",
      symbol: "ETH",
      address: "0x83Ef5bF6eBaCd6385919424d3bf29E3CEdFaB965",
      qrImage: "/assets/donate/eth.jpeg",
      icon: "Ξ",
      color: "ethereum",
    },
  ],
};

function Donate() {
  const [copied, setCopied] = useState("");

  const copyAddress = async (address, symbol) => {
    try {
      await navigator.clipboard.writeText(address);

      setCopied(symbol);

      setTimeout(() => {
        setCopied("");
      }, 2000);
    } catch (error) {
      console.error("Failed to copy address:", error);

      // Fallback untuk browser yang tidak mendukung clipboard API
      try {
        const textarea = document.createElement("textarea");

        textarea.value = address;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        document.execCommand("copy");

        document.body.removeChild(textarea);

        setCopied(symbol);

        setTimeout(() => {
          setCopied("");
        }, 2000);
      } catch (fallbackError) {
        console.error(
          "Fallback copy failed:",
          fallbackError
        );
      }
    }
  };

  return (
    <section
      className="donate-section"
      id="donate"
    >
      <div className="donate-container">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <div className="donate-header">

          <span className="donate-badge">
            SUPPORT US
          </span>

          <h2>
            Donate
          </h2>

          <p>
            Your support helps us keep this platform running,
            bring more content, and continue to improve the
            experience for everyone.
          </p>

          <span className="donate-thanks">
            Small help, big impact. Thank you! 💜
          </span>

        </div>


        {/* =====================================================
            PAYMENT PROCESSOR
        ===================================================== */}

        <div className="donate-group">

          <div className="donate-group-title">

            <div className="group-icon">
              💳
            </div>

            <div>
              <h3>
                Payment Processor
              </h3>

              <p>
                Support us via our trusted payment platform.
              </p>
            </div>

          </div>


          <div className="donate-card processor-card">

            {/* SAWERIA LOGO */}

            <div className="saweria-logo">
              S
            </div>


            {/* SAWERIA INFORMATION */}

            <div className="donate-card-content">

              <h3>
                {DONATE_CONFIG.saweria.name}
              </h3>

              <p>
                {DONATE_CONFIG.saweria.description}
              </p>

              <a
                href={DONATE_CONFIG.saweria.url}
                target="_blank"
                rel="noopener noreferrer"
                className="donate-button"
              >
                Donate via Saweria

                <span>
                  ↗
                </span>
              </a>

            </div>


            {/* SAWERIA QR */}

            <div className="saweria-qr-wrapper">

              <div className="qr-box">

                <QRCodeSVG
                  value={DONATE_CONFIG.saweria.url}
                  size={150}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"
                  includeMargin={true}
                />

              </div>

            </div>


            {/* SAWERIA DESCRIPTION */}

            <div className="saweria-qr-info">

              <h4>
                Scan QR Code
              </h4>

              <p>
                Scan atau klik tombol untuk membuka
                Saweria di browser.
              </p>

              <div className="donate-quote">

                <span>
                  “
                </span>

                Setiap dukungan sangat berarti
                untuk kami. Terima kasih!

                <span>
                  ”
                </span>

              </div>

            </div>

          </div>

        </div>


        {/* =====================================================
            DIRECT CRYPTO
        ===================================================== */}

        <div className="donate-group direct-group">

          <div className="donate-group-title">

            <div className="group-icon crypto-icon">
              ◉
            </div>

            <div>

              <h3>
                Direct Crypto
              </h3>

              <p>
                You can also support us directly
                using cryptocurrency.
              </p>

            </div>

          </div>


          <div className="wallet-grid">

            {DONATE_CONFIG.wallets.map(
              (wallet) => (

                <div
                  className={`wallet-card wallet-${wallet.color}`}
                  key={wallet.symbol}
                >

                  {/* =========================================
                      WALLET HEADER
                  ========================================= */}

                  <div className="wallet-header">

                    <div className="wallet-icon">
                      {wallet.icon}
                    </div>

                    <div>

                      <h3>
                        {wallet.name} ({wallet.symbol})
                      </h3>

                      <p>
                        Scan QR code or copy
                        the address below.
                      </p>

                    </div>

                  </div>


                  {/* =========================================
                      REAL WALLET QR IMAGE
                  ========================================= */}

                  <div className="crypto-qr">

                    <div className="qr-box crypto-qr-box">

                      <img
                        src={wallet.qrImage}
                        alt={`${wallet.name} QR Code`}
                        className="crypto-qr-image"
                        loading="lazy"
                      />

                    </div>

                  </div>


                  {/* =========================================
                      WALLET ADDRESS
                  ========================================= */}

                  <div className="wallet-address-row">

                    <div className="wallet-address">
                      {wallet.address}
                    </div>

                    <button
                      type="button"
                      className="mini-copy-button"
                      onClick={() =>
                        copyAddress(
                          wallet.address,
                          wallet.symbol
                        )
                      }
                      aria-label={`Copy ${wallet.symbol} address`}
                    >
                      {copied === wallet.symbol
                        ? "✓"
                        : "▣"}
                    </button>

                  </div>


                  {/* =========================================
                      COPY BUTTON
                  ========================================= */}

                  <button
                    type="button"
                    className="copy-address-button"
                    onClick={() =>
                      copyAddress(
                        wallet.address,
                        wallet.symbol
                      )
                    }
                  >

                    {copied === wallet.symbol
                      ? "✓ Address Copied"
                      : "▣ Copy Address"}

                  </button>

                </div>

              )
            )}

          </div>

        </div>


        {/* =====================================================
            INFORMATION
        ===================================================== */}

        <div className="donate-info">

          {/* SECURE */}

          <div className="donate-info-item">

            <div className="info-icon">
              🛡
            </div>

            <div>

              <h4>
                Secure & Safe
              </h4>

              <p>
                Your donation goes directly
                to our wallet or payment processor.
              </p>

            </div>

          </div>


          {/* GROW */}

          <div className="donate-info-item">

            <div className="info-icon">
              ♡
            </div>

            <div>

              <h4>
                Helps Us Grow
              </h4>

              <p>
                Your support keeps this platform
                running and helps us bring more
                great content.
              </p>

            </div>

          </div>


          {/* COMMUNITY */}

          <div className="donate-info-item">

            <div className="info-icon">
              👥
            </div>

            <div>

              <h4>
                Our Community
              </h4>

              <p>
                Together we can build a better
                and bigger community.
              </p>

            </div>

          </div>

        </div>


        {/* =====================================================
            FOOTER MESSAGE
        ===================================================== */}

        <div className="donate-footer-message">
          Thank you for your support! 💜
        </div>

      </div>
    </section>
  );
}

export default Donate;